<template>
    <div class="form-of-modal form-grat" v-if="formsData != null">
        <div class="form-of-modal-baner" v-if="formVisible">
            <div class="form-of-modal-bg" :style="'background-image: url(' + imgForm + ')'"></div>
            <strong>{{ titleForm }}</strong>
        </div>
        <form class="form-call-of-modal" v-if="formVisible">
            <div class="form-in" :class="{fadeOut : !formVisible}">
                <div class="form-group form-text" :class="{'error' : errors.has('name')}">
                    <label for="name">{{ formsData.form_contacts.name_label }}</label>
                    <input type="text" name="name" class="form-control" :placeholder="formsData.form_contacts.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                </div>
                <div class="form-group form-phone" :class="{'error' : errors.has('phone')}">
                    <label for="phone">{{ formsData.form_contacts.phone_label }}</label>
                    <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" placeholder="+7" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                </div>
                <div class="form-group form-text" :class="{'error' : errors.has('email')}" v-if="formsGlobalParam != 'call-page' && formsGlobalParam != 'call-page-get' && formsGlobalParam != 'flats-form' && formsGlobalParam != 'parking-form' && formsGlobalParam != 'storeroom-form' && formsGlobalParam != 'commerce-form'">
                    <label for="email">{{ formsData.form_contacts.email_label }}</label>
                    <input type="text" name="email" class="form-control" :placeholder="formsData.form_contacts.email_mask" v-model="email" v-validate="{ required: true, regex: regexRules.email }"  data-vv-delay="1000">
                </div>
                <div class="form-textarea" :class="{'error' : errors.has('textarea')}" v-if="formsGlobalParam != 'call-page' && formsGlobalParam != 'call-page-get' && formsGlobalParam != 'flats-form' && formsGlobalParam != 'parking-form' && formsGlobalParam != 'storeroom-form' && formsGlobalParam != 'commerce-form'">
                    <label>{{ formsData.form_contacts.comment_label }}</label>
                    <textarea class="form-control textarea-control" name="textarea" type="text" cols="50" rows="8" v-model="coomment" :placeholder="formsData.form_contacts.comment_mask" v-validate="{ required: true, regex: regexRules.msg }"  data-vv-delay="1000"/>
                </div>
                <div class="form-agree-politics">
                    <div class="form-check-elem">
                        <input type="checkbox" id="vacancyform-check-elem" v-model="politics_agree"> 
                        <label for="vacancyform-check-elem" v-if="globalLang != 'kz/'">{{formsData.form_contacts.btn_agree.def}} <router-link to="/data-policy">{{ formsData.form_contacts.btn_agree.link }}</router-link></label>
                        <label for="vacancyform-check-elem" v-else><router-link to="/data-policy">{{ formsData.form_contacts.btn_agree.link }}</router-link> {{formsData.form_contacts.btn_agree.def}}</label>
                    </div>
                </div>
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">
                        <span>{{formsData.form_contacts.btn_send}}</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </button>
                    <div class="anounce"><p>{{ formsData.form_contacts.anounce }}</p></div>
                </div>
                <div class="form-error-msg" v-if="errorAgreePolitics || errorMsg">
                    <p v-if="errorAgreePolitics">Вы не приняли политику обработки данных</p>
                    <p v-if="errorMsg">Заполните все поля</p>
                </div>
            </div>
        </form>
        <button class="close-link" @click.prevent="closeFormModalContainer">
            <svgIcon name="close" class="icon-close"/>
        </button>
        <div class="successMessage-form-of-modal" v-if="!formVisible">
            <h3 v-html="completeTitle"></h3>
            <button class="close-link" @click.prevent="closeFormModalContainer">
                <svgIcon name="close" class="icon-close"/>
            </button>
        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'formAboutVacancy',
        props: ['imgForm', 'titleForm', 'completeTitle'],
        data () {
            return {
                globalLang: window.GlobalLang, 
                name: '',
                phone: '',
                coomment: '',
                email: '',
                politics_agree: false,

                admin_mail: '',
                formVisible: true,
                errorMsg: false,
                errorAgreePolitics: false,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    email: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/,
                    msg: /^([а-яА-ЯёЁa-zA-Z0-9_\.\+-].*[\s\.]*){1,500}$/
                },
            }
        },
        components: {
            MaskedInput,
            svgIcon,
        },
        computed: mapGetters({
            formsData: 'loadFormsData',
            formsGlobalParam: 'loadFormsGlobalParam',
            formsGlobalData: 'loadFormsGlobalData',
            formsModalRealEstate: 'loadFormsModalRealEstate',
        }),
        methods: {
            closeFormModalContainer() {
                this.$modal.hide('form-modal-container');
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            },
            sendData() {
                var querystring = require('querystring');
                var urlForm = window.mainUrl + '/server/';
                var urlGoogleForm;
                var dataGoogleForm;
                var dataFormSend;
                var dataForm = {
                    'admin': this.formsData.admin_email,
                    'name': this.name,
                    'phone': this.phone,
                    'email': this.email,
                    'comment': this.coomment,
                    'page': this.formsGlobalData.page,
                    'block': this.formsGlobalData.block,
                    'subject': null,
                };
                const formConfig = {
                    'grat': {
                        dataFormSend: {...dataForm, subject: 'Новая благодарность с сайта dialgroup.kz', btn_name: 'Оставить благодарность'}, 
                        url: 'form-contact-us.php', 
                        dataGoogleFormID: '1FAIpQLSdfFAlXvTjdJLe0GJwkMLdrQGcmhESyiaPn7aZ_XjCObcP-6w',
                        dataGoogleForm: {
                            "entry.1410132176" : dataForm.name, 
                            "entry.1704106065" : dataForm.phone, 
                            "entry.502680134" : dataForm.email, 
                            "entry.935768908" : dataForm.comment, 
                            "entry.1385047797" : dataForm.page, 
                            "entry.368533696" : dataForm.block,
                            "entry.1621724545" : 'Оставить благодарность'
                        }, 
                    },
                    'call': {
                        dataFormSend: {...dataForm, subject: 'Новый запрос на диалог с сайта dialgroup.kz', btn_name: 'Связаться с нами'}, 
                        url: 'form-contact-us.php',
                        dataGoogleFormID: '1FAIpQLSfePNSWQm32aPi28W49D8yu-byZ3KqrDabyz-5VhYsedo8Z7Q',
                        dataGoogleForm: {
                            "entry.1938639971" : dataForm.name, 
                            "entry.1562371969" : dataForm.phone, 
                            "entry.592819797" : dataForm.email, 
                            "entry.53134091" : dataForm.comment, 
                            "entry.124946137" : dataForm.page, 
                            "entry.1939827436" : dataForm.block,
                            "entry.1621724545" : 'Связаться с нами'
                        }, 
                    },
                    'call-page': { 
                        dataFormSend: { admin: dataForm.admin, name: dataForm.name, phone: dataForm.phone, page: dataForm.page, block: dataForm.block, btn_name: 'Заказать консультацию',  subject: 'Заказ на консультацию с сайта dialgroup.kz'},
                        url: 'form-call-us.php',
                        dataGoogleFormID: '1FAIpQLSfsagKwwHVRQrMBwKyTmHNSMh4RX3ZDEGYxyvnUKcUcDI229Q',
                        dataGoogleForm: {
                            "entry.1480835855" : dataForm.name, 
                            "entry.952483517" : dataForm.phone, 
                            "entry.309943976" : dataForm.page, 
                            "entry.574596179" : dataForm.block,
                            "entry.2060956267" : 'Заказать консультацию',
                        }, 
                    },
                    'call-page-get': { 
                        dataFormSend: { admin: dataForm.admin, name: dataForm.name, phone: dataForm.phone, page: dataForm.page, block: dataForm.block, btn_name: 'Получить консультацию', subject: 'Заявка на получение консультации с сайта dialgroup.kz'},
                        url: 'form-call-us.php',
                        dataGoogleFormID: '1FAIpQLSe85qGWi5TbzfvkBTldfAlK4XhAg9MERMD-KrUz_YagyZNR5Q',
                        dataGoogleForm: {
                            "entry.414219450" : dataForm.name, 
                            "entry.602437390" : dataForm.phone, 
                            "entry.744522908" : dataForm.page, 
                            "entry.217940844" : dataForm.block,
                            "entry.206315173" : 'Получить консультацию',
                        },
                    },
                    'flats-form' : {
                        dataFormSend: { 
                            admin: dataForm.admin, 
                            name: dataForm.name, 
                            phone: dataForm.phone, 
                            project: this.formsModalRealEstate.project,
                            id: this.formsModalRealEstate.id,
                            part: this.formsModalRealEstate.part,
                            rooms: this.formsModalRealEstate.rooms,
                            size: this.formsModalRealEstate.size,
                            price: this.formsModalRealEstate.price,
                            link: this.formsModalRealEstate.link,
                            page: dataForm.page, 
                            block: dataForm.block, 
                            btn_name: 'Оставить заявку', 
                            subject: 'Заявка по квартире с сайта dialgroup.kz'
                        },
                        url: 'form-estate-call.php',
                        dataGoogleFormID: '1FAIpQLSdjps_qHFVT3PGo1xl0fzzYdCMnIAwSDH1lu1sbdOwyo6queg',
                        dataGoogleForm: {
                            "entry.1781834924" : dataForm.name, 
                            "entry.2086207898" : dataForm.phone, 
                            "entry.1245636319" : this.formsModalRealEstate.project, 
                            "entry.1130034413" : this.formsModalRealEstate.id, 
                            "entry.876044785" : this.formsModalRealEstate.size, 
                            "entry.1460887080" : this.formsModalRealEstate.rooms, 
                            "entry.1820543920" : this.formsModalRealEstate.part, 
                            "entry.2138723017" : this.formsModalRealEstate.price, 
                            "entry.1352957323" : this.formsModalRealEstate.link, 
                            "entry.45541396" : dataForm.page, 
                            "entry.557030140" : dataForm.block,
                            "entry.1365417928" : 'Оставить заявку',
                        },
                    },
                    'parking-form' : {
                        dataFormSend: { 
                            admin: dataForm.admin, 
                            name: dataForm.name, 
                            phone: dataForm.phone, 
                            project: this.formsModalRealEstate.project,
                            id: this.formsModalRealEstate.id,
                            part: this.formsModalRealEstate.part,
                            type: this.formsModalRealEstate.type,
                            level: this.formsModalRealEstate.level,
                            size: this.formsModalRealEstate.size,
                            price: this.formsModalRealEstate.price,
                            page: dataForm.page, 
                            block: dataForm.block, 
                            btn_name: 'Оставить заявку', 
                            subject: 'Заявка по паркингу с сайта dialgroup.kz'
                        },
                        url: 'form-estate-call.php',
                        dataGoogleFormID: '1FAIpQLScrF3NfgZi7rqVjP5b_5kpNFOIsMuuKc2vEBeHAQ8Nvi5TqBA',
                        dataGoogleForm: {
                            "entry.2067772374" : dataForm.name, 
                            "entry.83542856" : dataForm.phone, 
                            "entry.1681900361" : this.formsModalRealEstate.project, 
                            "entry.1186174518" : this.formsModalRealEstate.id, 
                            "entry.567865049" : this.formsModalRealEstate.type, 
                            "entry.1156003031" : this.formsModalRealEstate.level, 
                            "entry.572242540" : this.formsModalRealEstate.size, 
                            "entry.1455899388" : this.formsModalRealEstate.part, 
                            "entry.303084844" : this.formsModalRealEstate.price, 
                            "entry.109264239" : dataForm.page, 
                            "entry.1247805456" : dataForm.block,
                            "entry.501996689" : 'Оставить заявку',
                        },
                    },
                    'storeroom-form' : {
                        dataFormSend: { 
                            admin: dataForm.admin, 
                            name: dataForm.name, 
                            phone: dataForm.phone, 
                            project: this.formsModalRealEstate.project,
                            id: this.formsModalRealEstate.id,
                            part: this.formsModalRealEstate.part,
                            type: this.formsModalRealEstate.type,
                            level: this.formsModalRealEstate.level,
                            size: this.formsModalRealEstate.size,
                            price: this.formsModalRealEstate.price,
                            page: dataForm.page, 
                            block: dataForm.block, 
                            btn_name: 'Оставить заявку', 
                            subject: 'Заявка по кладовой с сайта dialgroup.kz'
                        },
                        url: 'form-estate-call.php',
                        dataGoogleFormID: '1FAIpQLSfApm0zD7fJmvjaKKUDMyPv5mDocWIcrEUW15kYX_ggjfgAAA',
                        dataGoogleForm: {
                            "entry.1980057696" : dataForm.name, 
                            "entry.1051766560" : dataForm.phone, 
                            "entry.1786889410" : this.formsModalRealEstate.project, 
                            "entry.1799798097" : this.formsModalRealEstate.id, 
                            "entry.1825033695" : this.formsModalRealEstate.type, 
                            "entry.705812974" : this.formsModalRealEstate.level, 
                            "entry.1666932013" : this.formsModalRealEstate.size, 
                            "entry.743296845" : this.formsModalRealEstate.part, 
                            "entry.563306487" : this.formsModalRealEstate.price, 
                            "entry.751466867" : dataForm.page, 
                            "entry.1698267125" : dataForm.block,
                            "entry.1236275521" : 'Оставить заявку',
                        },
                    },
                    'commerce-form' : {
                        dataFormSend: { 
                            admin: dataForm.admin, 
                            name: dataForm.name, 
                            phone: dataForm.phone, 
                            nameCard: this.formsModalRealEstate.name_card,
                            adres: this.formsModalRealEstate.adres,
                            project: this.formsModalRealEstate.project,
                            id: this.formsModalRealEstate.id,
                            type: this.formsModalRealEstate.type,
                            level: this.formsModalRealEstate.level,
                            part: this.formsModalRealEstate.part,
                            size: this.formsModalRealEstate.size,
                            price: this.formsModalRealEstate.price,
                            page: dataForm.page, 
                            block: dataForm.block, 
                            btn_name: 'Оставить заявку', 
                            subject: 'Заявка по коммерции с сайта dialgroup.kz'
                        },
                        url: 'form-estate-call.php',
                        dataGoogleFormID: '1FAIpQLSeSTFB-Xpdt1EI21DlqLOsCWljW0AQnVqx9pliCNt-_5vOZDg',
                        dataGoogleForm: {
                            "entry.417764047" : dataForm.name, 
                            "entry.141501026" : dataForm.phone, 
                            "entry.481684118" : this.formsModalRealEstate.name_card, 
                            "entry.1049988000" : this.formsModalRealEstate.project, 
                            "entry.881898844" : this.formsModalRealEstate.id, 
                            "entry.117961746" : this.formsModalRealEstate.type, 
                            "entry.34951407" : this.formsModalRealEstate.level, 
                            "entry.79233477" : this.formsModalRealEstate.size, 
                            "entry.950595133" : this.formsModalRealEstate.part, 
                            "entry.1635880056" : this.formsModalRealEstate.price, 
                            "entry.1651643906" : dataForm.page, 
                            "entry.1633580191" : dataForm.block,
                            "entry.2054858254" : 'Оставить заявку',
                        },
                    }
                };
                const config = formConfig[this.formsGlobalParam];
                this.$validator.validate().then(result => {
                    if(result) {
                        this.errorMsg = false;
                        if (this.politics_agree) {
                            this.errorAgreePolitics = false;
                            this.formVisible = false
                            dataFormSend = {};
                            if (config) {
                                dataFormSend = config.dataFormSend;
                                urlForm = urlForm + config.url;
                                console.log(this.formsModalRealEstate, 'asdasdasd')
                                axios.post(urlForm, querystring.stringify(dataFormSend));
                                $.ajax({
                                    url: "https://docs.google.com/forms/d/e/" + config.dataGoogleFormID + "/formResponse",
                                    data: config.dataGoogleForm,
                                    type: "GET",
                                    dataType: "xml"
                                });
                                console.log(config);
                                console.log(dataFormSend);
                                console.log(urlForm);
                            }
                            // console.log(querystring.stringify(dataForm))
                        } else {
                            this.errorAgreePolitics = true;
                            console.log('Data policy is not agree');
                        } 
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/forms-of-modal/form-of-modal.scss';
    @import '@/styles/components/forms/forms-of-modal/respond/form-of-modal-respond.scss';
    // @import '@/styles/components/forms/respond/form-vacancy-respond.scss';
</style>